import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

interface WaitingReasonDialogProps {
  open: boolean;
  companyName?: string | null;
  isSubmitting?: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

const WaitingReasonDialog = ({
  open,
  companyName,
  isSubmitting = false,
  onConfirm,
  onCancel,
}: WaitingReasonDialogProps) => {
  const [reason, setReason] = useState('');
  const isValid = reason.trim().length > 0;

  const handleConfirm = () => {
    if (!isValid || isSubmitting) {
      return;
    }
    onConfirm(reason.trim());
  };

  const handleCancel = () => {
    if (isSubmitting) {
      return;
    }
    setReason('');
    onCancel();
  };

  const handleExited = () => {
    setReason('');
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      maxWidth="sm"
      fullWidth
      disableScrollLock
      TransitionProps={{ onExited: handleExited }}>
      <DialogTitle>Set Model to Waiting</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {companyName ? (
            <>
              <strong>{companyName}</strong> is being placed on hold.{' '}
            </>
          ) : null}
          Please explain why this model is being set to Waiting. This will be saved as the latest
          note on the Valuation.
        </Typography>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={3}
          label="Waiting reason *"
          placeholder="e.g. Client hasn't provided cap table. Following up next week."
          value={reason}
          onChange={e => setReason(e.target.value)}
          disabled={isSubmitting}
          inputProps={{ 'data-testid': 'waiting-reason-input' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} disabled={isSubmitting} data-testid="waiting-reason-cancel">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={!isValid || isSubmitting}
          variant="contained"
          data-testid="waiting-reason-confirm">
          Confirm &amp; Set Waiting
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WaitingReasonDialog;
